import React, { useEffect, useState } from "react";
import axios from "../../config/authaxios";

import Chip from "@material-ui/core/Chip";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import moment from "moment";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import JoditEditor from "jodit-react";

import { useLocation, useNavigate } from "react-router-dom";

import {
  Button,
  Card,
  Checkbox,
  FormControlLabel,
  FormGroup,
  TextField,
  Typography,
  Stack,
  Box,
} from "@mui/material";
import CountrySelect from "../../ui/CountrySelect";
import { getCountryId } from "../../services/countries";

function Edit() {
  const search = useLocation().search;
  const navigate = useNavigate();
  const couponId = new URLSearchParams(search).get("couponId");

  const [coupons, setCoupons] = useState({});
  const [priceArray, setPriceArray] = useState([]);
  const [priceInput, setPriceInput] = useState([]);
  const [expiry, setExpiry] = useState();

  const [image, setImage] = useState();
  const [smallImage, setSmallImage] = useState();

  const [pointArray, setPointArray] = useState([]);
  const [pointInput, setPointInput] = useState("");
  const [detailColorArray, setDetailColorArray] = useState([
    "#000",
    "#000",
    "#000",
  ]);
  const [countryId, setCountryId] = useState("");
  //   const [page, setPage] = useState(0);
  //   const [limit, setLimit] = useState(10);
  //   const [isUsed, setIsUsed] = useState(false);
  //   const [isMore, setIsMore] = useState(false);
  //   const [load, setLoad] = useState(false);
  //   const [nodata, setNodata] = useState(false);

  const fetchCouponDetail = () => {
    axios.get(`/admin/coupon-detail/${couponId}`).then((res) => {
      //console.log(res.data.response);
      let data = res.data.response;
      if (res.data.status) {
        setCoupons({
          ...res.data.response,
          redeem_method: Array.isArray(res.data.response?.redeem_method)
            ? res.data.response.redeem_method
            : [],
          note: res.data.response?.note ?? "",
        });
        setPriceArray(res.data.response.price.denominations);
        setImage(res.data.response.images.mobile);
        setPointArray(res.data.response.how_to_use_points||[]);
        setDetailColorArray(
          res.data.response.detail_colors.length == 0
            ? ["#000", "#000", "#000"]
            : res.data.response.detail_colors
        );
        setExpiry(
          moment(res?.data?.response?.expiry).format("YYYY-MM-DDTHH:MM")
        );
        setCountryId(getCountryId(res.data.response?.country));
        // setExpiry(res?.data?.response?.expiry)
      }
    });
  };

  useEffect(() => {
    fetchCouponDetail();

    //   return () => {
    //     setCoupons()
    //   }
  }, []);

  const handlefileInput = (e) => {
    const Dataform = new FormData();
    Dataform.append("file", e.target.files[0]);
    let FileSize = Number(e.target.files[0].size / 1000);
    var file = e.target.files[0];
    var _URL = window.URL || window.webkitURL;
    let img = new Image();
    var width, height;
    img.onload = function () {
      // //console.log(img, file);
      width = this.width;
      height = this.height;
      // if (FileSize > 5000) {
      //     return alert(`Image should be to under 50kb reupload image, Your file size is ${FileSize}`)
      // }
      // if (height <= 250 && height > 150 && width <= 1352 && width > 450) {
      //console.log(Dataform);
      axios.post(`/admin/upload-image`, Dataform).then((res) => {
        //console.log(">>Image_url>>", res.data.Image.url);
        let data = res.data.Image.url;
        // setCoupons({ ...coupons,image: res.data.Image.url });
        setImage(data);
        //console.log("image-->",image)
      });
      alert(`Image is Successfully Uploaded, Your file size is ${FileSize}`);
      // } else {
      //   alert(
      //     `Image height less then 250 & greater then 150 width less then 1352 & greater then 450, Your height=${height} & width=${width}`
      //   );
      // }
    };
    img.onerror = function () {
      alert("not a valid file: " + file.type);
    };
    img.src = _URL.createObjectURL(file);
  };

  const onChangeHandler = (e) => {
    //console.log("id-->",e.target.id,e.target.value)
    setCoupons({ ...coupons, [e.target.id]: e.target.value });
  };

  const onToggleRedeemMethod = (value) => (e) => {
    const checked = e.target.checked;
    setCoupons((prev) => {
      const current = Array.isArray(prev.redeem_method) ? prev.redeem_method : [];
      if (checked) return { ...prev, redeem_method: Array.from(new Set([...current, value])) };
      return { ...prev, redeem_method: current.filter((v) => v !== value) };
    });
  };

  const AddPriceInArray = () => {
    let temp = priceArray;
    //console.log("priceinput-->",priceInput)
    temp.push(...priceInput);
    //console.log("temp-->",temp)
    setPriceArray(temp);
    setPriceInput("");
  };

  const handleDeleteRule = (index) => {
    let temp = priceArray;
    temp.splice(index, 1);
    setPriceArray([...temp]);
  };

  const AddPointInArray = () => {
    let temp = pointArray;
    temp.push(...pointInput);
    setPointArray(temp);
    setPointInput("");
  };

  const handleDeletePoint = (index) => {
    let temp = pointArray;
    temp.splice(index, 1);
    setPointArray([...temp]);
  };

  const onChangeHandlerColor = (index, newColor) => {
    const updatedColors = [...detailColorArray];
    updatedColors[index] = newColor;
    setDetailColorArray(updatedColors);
    console.log(detailColorArray);
  };

  const updateHandler = () => {
    let obj = { ...coupons };
    obj._id = couponId;
    obj.name = coupons.name;
    obj.image = image;
    obj.description = coupons.description;
    obj.price = priceArray;
    obj.expiry = moment(expiry).format("YYYY-MM-DD[T00:00:00.000Z]");
    obj.detail_colors=detailColorArray;
    obj.how_to_use_points=pointArray
    obj.outer_color=coupons.outer_color||'#000'
    obj.redeem_method = (Array.isArray(coupons.redeem_method) ? coupons.redeem_method : []).map(Number);
    obj.note = coupons.note ? String(coupons.note) : null;
    obj.country = countryId;

    console.log("obj-->", obj);
    axios.put(`/admin/update-coupon`, obj).then((res) => {
      //console.log(res);
      // let data = res.data.response;
      alert(res.data.message);
      navigate("/getallcoupon");
    });
  };

  return (
    <>
      <Card sx={{ p: 4 }}>
        <section>
          <section>
            <Typography> Name :</Typography>
            <TextField
              fullWidth
              type="text"
              className="rounded  py-2"
              id="name"
              value={coupons.name}
              onChange={onChangeHandler}
              // placeholder="Enter App version"
            />
          </section>
          <section>
            <Typography>Description :</Typography>
            <ReactQuill
              theme="snow"
              value={coupons.description}
              onChange={(e) => {
                setCoupons({ ...coupons, description: e });
              }}
            />
          </section>

          <section>
            <Typography>Image :</Typography>
            {image ? (
              <Button
                color="info"
                variant="contained"
                sx={{ my: 2 }}
                onClick={() => {
                  setImage("");
                }}
              >
                Re-Upload
              </Button>
            ) : (
              <>
                <label htmlFor="image">
                  <input
                    accept="image/*"
                    id="image"
                    type="file"
                    onChange={handlefileInput}
                    style={{ display: "none" }}
                  />
                  <Button
                    variant="contained"
                    component="span"
                    endIcon={<DriveFolderUploadIcon />}
                    color="info"
                  >
                    Upload Image
                  </Button>
                </label>
              </>
            )}
            {/* <Input
              type="file"
              className="rounded  py-2"
              id="image"
              value={image}
              onChange={handlefileInput}
              accept="image/*"
            /> */}
            {/* <img src={image}/> */}
          </section>

          <section>
            <Typography>Small Image :</Typography>
            {smallImage ? (
              <Button
                color="info"
                variant="contained"
                sx={{ my: 2 }}
                onClick={() => {
                  setSmallImage("");
                }}
              >
                Re-Upload
              </Button>
            ) : (
              <>
                <label htmlFor="small">
                  <input
                    accept="image/*"
                    id="small"
                    type="file"
                    onChange={handlefileInput}
                    style={{ display: "none" }}
                  />
                  <Button
                    variant="contained"
                    component="span"
                    endIcon={<DriveFolderUploadIcon />}
                    color="info"
                  >
                    Upload Small Image
                  </Button>
                </label>
              </>
            )}
          </section>
        </section>
        <section>
          <section>
            <Typography>Country :</Typography>
            <CountrySelect value={countryId} onChange={setCountryId} />
          </section>
          <section>
            <Typography> Expiry :</Typography>
            {/* {console.log("expiry", expiry)} */}
            <TextField
              fullWidth
              type="datetime-local"
              className="rounded  py-2"
              id="expiry"
              value={expiry}
              onChange={(e) => {
                setExpiry(e.target.value);
              }}
            />
          </section>

          <Stack spacing={1}>
            <Typography> Price :</Typography>
            <TextField
              fullWidth
              type="number"
              className="rounded  py-2"
              onKeyDown={(evt) =>
                ["e", "E", "+", "-", " "].includes(evt.key) &&
                evt.preventDefault()
              }
              id="price"
              value={priceInput}
              onChange={(e) => {
                e.target.value > 0
                  ? setPriceInput([e.target.value])
                  : setPriceInput();
              }}
            />
            <Box>
              <Button
                variant="contained"
                color="info"
                disabled={priceInput ? false : true}
                onClick={AddPriceInArray}
              >
                {priceInput ? "Add Price" : "Enter Price"}
              </Button>
            </Box>
          </Stack>
          <section>
            {priceArray.length > 0 &&
              priceArray.map((item, index) => {
                return (
                  <Chip
                    key={index}
                    onDelete={() => {
                      handleDeleteRule(index);
                    }}
                    label={item}
                  />
                );
              })}
          </section>

          <section>
            <Typography> Partner Link :</Typography>
            <TextField
              fullWidth
              type="text"
              className="rounded  py-2"
              id="partner_link"
              value={coupons.partner_link}
              onChange={onChangeHandler}
              // placeholder="Enter App version"
            />
          </section>

          <section>
            <Typography> Percentage :</Typography>
            <TextField
              fullWidth
              type="text"
              className="rounded  py-2"
              id="c_percentage"
              value={coupons.c_percentage}
              onChange={onChangeHandler}
              // placeholder="Enter App version"
            />
          </section>

          <section>
            <Typography>Redeem Method :</Typography>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={(coupons.redeem_method || []).includes(1)}
                    onChange={onToggleRedeemMethod(1)}
                  />
                }
                label="Online"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={(coupons.redeem_method || []).includes(2)}
                    onChange={onToggleRedeemMethod(2)}
                  />
                }
                label="Offline"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={(coupons.redeem_method || []).includes(3)}
                    onChange={onToggleRedeemMethod(3)}
                  />
                }
                label="Combine"
              />
            </FormGroup>
          </section>

          <section>
            <Typography> Note :</Typography>
            <TextField
              fullWidth
              multiline
              minRows={3}
              id="note"
              value={coupons.note ?? ""}
              onChange={onChangeHandler}
            />
          </section>

          <section>
            <Typography>How to use Description :</Typography>

            <JoditEditor
              tabIndex={5}
              id="how_to_use_desc"
              value={coupons.how_to_use_desc}
              onBlur={(e) => {
                setCoupons({ ...coupons, how_to_use_desc: e });
              }}
              onChange={(e) => {
                setCoupons({ ...coupons, how_to_use_desc: e });
              }}
            />
          </section>


          <section>
            <Typography>Brand Description :</Typography>

            <JoditEditor
              tabIndex={5}
              id="brand_desc"
              value={coupons.brand_desc}
              onBlur={(e) => {
                setCoupons({ ...coupons, brand_desc: e });
              }}
              onChange={(e) => {
                setCoupons({ ...coupons, brand_desc: e });
              }}
            />
          </section>

          <Stack spacing={1}>
            <Typography> How to use points :</Typography>
            <TextField
              fullWidth
              type="text"
              className="rounded  py-2"
              // onKeyDown={(evt) => ["e", "E", "+", "-", " "].includes(evt.key) && evt.preventDefault()}
              id="price"
              value={pointInput}
              onChange={(e) => {
                setPointInput([e.target.value]);
              }}
            />
            <Box>
              <Button
                variant="contained"
                color="info"
                disabled={pointInput ? false : true}
                onClick={AddPointInArray}
              >
                {pointInput ? "Add Point" : "Enter Point"}
              </Button>
            </Box>
          </Stack>
          <section>
            {pointArray?.length > 0 &&
              pointArray.map((item, index) => {
                return (
                  <Chip
                    key={index}
                    onDelete={() => {
                      handleDeletePoint(index);
                    }}
                    label={item}
                  />
                );
              })}
          </section>

          <section>
            <Typography> Outer Color :</Typography>
            <TextField
              type="color"
              className="rounded  py-2"
              style={{ width: "100px" }}
              id="outer_color"
              value={coupons.outer_color}
              onChange={onChangeHandler}

              // onClick={closeHandler}s
              // placeholder="Enter App version"
            />
          </section>

          <section style={{ display: "flex", flexDirection: "column" }}>
            <Typography> Detail color :</Typography>

            <div>
              {/* {JSON.stringify(detailColorArray)} */}
              {detailColorArray.map((color, index) => (
                <TextField
                  key={index}
                  type="color"
                  className="rounded py-2"
                  id={`detail_color${index}`}
                  xw
                  // value={color}
                  value={color}
                  onChange={(e) => onChangeHandlerColor(index, e.target.value)}
                  style={{ width: "100px", margin: "10px" }}
                />
              ))}
            </div>
          </section>
        </section>
        <Button
          color="info"
          variant="contained"
          sx={{ my: 2 }}
          onClick={updateHandler}
        >
          Update
        </Button>
      </Card>
    </>
  );
}

export default Edit;
